import { createFileRoute } from "@tanstack/react-router";
import { SellFlow } from "@/components/SellFlow";

export const Route = createFileRoute("/es/crear")({
  head: () => ({
    meta: [
      { title: "Crear anuncio – haz una foto y publica gratis | Sellavo" },
      { name: "description", content: "Fotografía tu objeto y Sellavo escribe el título, la descripción y el precio por ti." },
      { property: "og:title", content: "Crear anuncio – haz una foto y publica gratis | Sellavo" },
      { property: "og:description", content: "Fotografía tu objeto y Sellavo escribe el título, la descripción y el precio por ti." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/es/crear" }],
  }),
  component: () => <SellFlow variant="create" />,
});
